import { makeAutoObservable, runInAction } from 'mobx';
import { getF1PasswordManagement, updateF1PasswordManagement } from '../../data/Config/F1PasswordManagement/repositories/f1PasswordManagementRepository';
import { F1PasswordManagement, GetF1PasswordManagementRequest, UpdateF1PasswordManagementRequest } from '../../models/config/F1PasswordManagement';
//import { F1PasswordManagement, GetF1PasswordManagementRequest, UpdateF1PasswordManagementRequest } from '../../data/Config/F1PasswordManagement/schemas';
import RootStore from '../Root.store';

class F1PasswordManagementStore {
    private _f1PassswordManagement: F1PasswordManagement[] = [];

    public get f1PassswordManagement() {
        return this._f1PassswordManagement;
    }

    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    public async fetchF1PasswordManagement(f1PasswordManagementSearch: GetF1PasswordManagementRequest) {
        const [error, f1PasswordManagementResponse] = await getF1PasswordManagement(f1PasswordManagementSearch);
        if (error) {
            throw error;
        }
        runInAction(() => {
            this._f1PassswordManagement = f1PasswordManagementResponse;
        });
    }

    public async updateF1PasswordManagement(updateF1PasswordManagementRequest: UpdateF1PasswordManagementRequest) {
        const [error, f1PasswordManagementResponse] = await updateF1PasswordManagement(updateF1PasswordManagementRequest);
        if (error) {
            throw error;
        }
        runInAction(() => {
            //this._f1PassswordManagement = f1PasswordManagementResponse;
        });
    }
}

export default F1PasswordManagementStore;
